import { AxiosRequestConfig, AxiosResponse } from "axios";
import { BaseSchool } from "./bases/base.service";
import type { SalesToken } from "@/store/school/types";

export default class SchoolService {
  public getSchoolRequestDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`request/detail/${params?.code}`, { params });
  }
  public addSchoolRequest(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("request/add", params);
  }
  public schoolRequestRegister(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("request/register", params);
  }
  public schoolRequestRegisterFree(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("request/register-free", params);
  }
  public schoolRequestValidateToken<T = Respon<SalesToken>>(params: any = {}, config?: AxiosRequestConfig) {
    return BaseSchool().post<T>("request/sales/validate-token", params, config);
  }
  public schoolRequestSalesRegister<T = Respon<string>>(params: any = {}) {
    return BaseSchool().post<T>("request/sales/register", params);
  }
  public schoolRequestSendOTP<T = Respon<string>>(params: any = {}) {
    return BaseSchool().post<T>("request/send/otp", params);
  }
  public schoolRequestValidateOTP<T = Respon<string>>(params: any = {}) {
    return BaseSchool().post<T>("request/validate/otp", params);
  }
}
